/**
 * @generated SignedSource<<26b9af4aa6735295df459878958c4226>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type TodoCategoryScreenTodoDeleteSubscription$variables = {
  categoryId: string;
  teamId: string;
};
export type TodoCategoryScreenTodoDeleteSubscription$data = {
  readonly todoDeleted: {
    readonly id: string;
  } | null;
};
export type TodoCategoryScreenTodoDeleteSubscription = {
  response: TodoCategoryScreenTodoDeleteSubscription$data;
  variables: TodoCategoryScreenTodoDeleteSubscription$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "categoryId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "teamId"
  }
],
v1 = [
  {
    "items": [
      {
        "kind": "Variable",
        "name": "categoryIds.0",
        "variableName": "categoryId"
      }
    ],
    "kind": "ListValue",
    "name": "categoryIds"
  },
  {
    "items": [
      {
        "kind": "Variable",
        "name": "teamIds.0",
        "variableName": "teamId"
      }
    ],
    "kind": "ListValue",
    "name": "teamIds"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "TodoCategoryScreenTodoDeleteSubscription",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "Todo",
        "kind": "LinkedField",
        "name": "todoDeleted",
        "plural": false,
        "selections": [
          (v2/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Subscription",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "TodoCategoryScreenTodoDeleteSubscription",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "Todo",
        "kind": "LinkedField",
        "name": "todoDeleted",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "filters": null,
            "handle": "deleteRecord",
            "key": "",
            "kind": "ScalarHandle",
            "name": "id"
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "b156b305e3f825c96b0f7620acd76e6f",
    "id": null,
    "metadata": {},
    "name": "TodoCategoryScreenTodoDeleteSubscription",
    "operationKind": "subscription",
    "text": "subscription TodoCategoryScreenTodoDeleteSubscription(\n  $categoryId: ID!\n  $teamId: ID!\n) {\n  todoDeleted(categoryIds: [$categoryId], teamIds: [$teamId]) {\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "890f82bfcf1c21202f3a8e6830302226";

export default node;
